module.exports = __webpack_public_path__ + "img/commas-black.bf0efcb6.svg";